export interface IIntegrationChannel {
  id: string;
  integration: string;
  provider_id: string;
  location_id: string;
  status: string;
}

export interface IIntegrationChannelData {
  data: IIntegrationChannel[];
}

export interface IIntegrationSetting {
  key: string;
  value: string;
  name?: string;
}

export interface IPostIntegrationChannel {
  [key: string]: string | any[];
  start_date: string;
  end_date: string;
  provider_id: string;
  integration: 'magicline';
  country_code: string;
  settings: [
    { key: 'api_key'; value: string },
    { key: 'webhook_key'; value: string },
    { key: 'url'; value: string },
  ];
}

export interface IPostEversportsChannel {
  [key: string]: string | any[];
  start_date: string;
  end_date: string;
  provider_id: string;
  integration: 'eversports';
  country_code: string;
  settings: [{ key: 'venue_id'; value: string }, { key: 'venue_uuid'; value: string }];
}
export interface IPostVirtuaGymChannel {
  [key: string]: string | any[];
  start_date: string;
  end_date: string;
  provider_id: string;
  integration: 'virtuagym';
  settings: [{ key: 'club_id'; value: string }];
}

export interface IPostZingfitChannel {
  [key: string]: string | any[];
  start_date: string;
  end_date: string;
  provider_id: string;
  integration: 'virtuagymv1';
  country_code: string;
  settings: [
    { key: 'club_id'; value: string },
    { key: 'club_secret'; value: string },
    { key: 'schedule_id'; value: number },
  ];
}
export interface IPostVirtuaGymV1Channel {
  [key: string]: string | any[];
  start_date: string;
  end_date: string;
  provider_id: string;
  integration: 'virtuagymv1';
  country_code: string;
  settings: [
    { key: 'club_id'; value: string },
    { key: 'club_secret'; value: string },
    { key: 'schedule_id'; value: number },
  ];
}

export interface IPostMindbodyChannel {
  [key: string]: string | any[];
  start_date: string;
  end_date: string;
  provider_id: string;
  integration: 'mindbody';
  country_code: string;
  settings: [
    { key: 'api_key'; value: string },
    { key: 'site_id'; value: string },
    { key: 'location_id'; value: string },
    { key: 'staff_username'; value: string },
    { key: 'staff_password'; value: string },
    { key: 'service_id'; value: string },
  ];
}

export interface IPostResamaniaChannel {
  [key: string]: string | any[];
  start_date: string;
  end_date: string;
  provider_id: string;
  integration: 'resamania';
  settings: [
    { key: 'studio_id'; value: string },
    { key: 'network_id'; value: string },
    { key: 'club_id'; value: string },
    { key: 'client_token'; value: string },
    { key: 'country_code'; value: string },
  ];
}

export interface IUpdateIntegrationChannel {
  start_date: string;
  end_date: string;
  settings: IIntegrationSetting[];
  country_code: string;
}

export interface IIntegrationChannelById {
  [key: string]: string | any[];
  id: string;
  provider_id: string;
  location_id: string;
  integration: string;
  status: string;
  start_date: string;
  end_date: string;
  settings: IIntegrationSetting[];
}

export interface IVirtuaGymChannelById {
  [key: string]: string | any[];
  id: string;
  provider_id: string;
  location_id: string;
  integration: string;
  status: string;
  start_date: string;
  end_date: string;
  country_code: string;
  settings: IIntegrationSetting[];
}

export interface IVirtuaGymV1ChannelById {
  [key: string]: string | any[];
  location_id: string;
  start_date: string;
  end_date: string;
  country_code: string;
  settings: [
    { key: 'club_id'; value: string },
    { key: 'club_key'; value: string },
    { key: 'schedule_id'; value: string },
  ];
}
export interface IEversportsChannelById {
  [key: string]: string | any[];
  id: string;
  provider_id: string;
  location_id: string;
  integration: string;
  status: string;
  start_date: string;
  end_date: string;
  country_code: string;
  settings: [{ key: 'venue_id'; value: string }];
}

export interface IZingfitChannelById {
  [key: string]: string | any[];
  location_id: string;
  integration: string;
  status: string;
  start_date: string;
  end_date: string;
  country_code: string;
  settings: IIntegrationSetting[];
}

export interface IIntegrationChannelByIdData {
  data: IIntegrationChannelById;
}

export interface ChannelCategory {
  name: string;
  key: string;
  value: string;
  ignored: boolean;
  seats_limit: number | string;
}

export interface ChannelUpdateCategory {
  key: string;
  value: string;
  ignored: boolean;
}

export interface channelCategories {
  data: ChannelCategory[];
}

export enum IntegrationTypes {
  Magicline = 'magicline',
  Eversports = 'eversports',
  Virtuagym = 'virtuagym',
  Zingfit = 'zingfit',
  Mindbody = 'mindbody',
  VirtuagymV1 = 'virtuagymv1',
  Resamania = 'resamania',
}
